import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { defaultDuration } from "./constants";
import { UIState } from "./state";

const initialState: UIState = {
  snackbarMessage: "",
  snackbarLevel: "info",
  snackbarIsOpen: false,
};

export const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    openSnackbar: (
      state,
      action: PayloadAction<{
        level: "success" | "error" | "info";
        message: string;
        duration?: number;
      }>
    ) => {
      const { level, message, duration } = action.payload;
      state.snackbarMessage = message;
      state.snackbarLevel = level;
      state.snackbarIsOpen = true;

      if (state.snackbarLevel === "error") {
        state.snackbarDuration = undefined;
      } else if (state.snackbarLevel === "info") {
        state.snackbarDuration = undefined;
      } else {
        state.snackbarDuration = duration ?? defaultDuration;
      }
    },
    closeSnackbar: (state) => {
      state.snackbarIsOpen = false;
    },
  },
});

export const { openSnackbar, closeSnackbar } = uiSlice.actions;

export default uiSlice.reducer;
